<template>
    <el-date-picker
        v-bind:class="type === isType ? (value ? 'success' : 'danger') : ''"
        v-model="value"
        placeholder="Select Date"
        @change="onDateChange(type, name, $event)"
        size="small" v-if="!data"
    ></el-date-picker>
    <span v-else>{{ data }}</span>
</template>
<script>
export default {
    name: 'resolve-date',
    data() {
        return {
            value: ""
        }
    },
    props: {
        isType: {
            type: String,
            required: true
        },
        data: {
            type: [String, Boolean],
            required: true
        },
        type: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        }
    },
    methods: {
        onDateChange(type, name, event) {
            this.$emit('changeDate', {
                type,
                name,
                event: new Date(event).toDateString()
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .success {
        input {
            border-color: rgb(103, 194, 58) !important;
            background-color: #f6fff8;
        }
    }

    .danger {
        input {
            border-color: rgb(245, 108, 108) !important;
        }
    }
</style>